import { AgGridButtons } from "@/controls/buttons/AgGridButtons";
import { CasterScrapReason } from "@/pages/caster/models/Catalogs";
import { ScrapData } from "@/pages/caster/models/ScrapData";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-community";

interface UseScrapTableDataProps {
	scrapReasons: CasterScrapReason[];
	editCallback: (scrap: ScrapData) => void;
	deleteCallback: (scrap: ScrapData) => void;
}

const formatLength = (lengthInInches: number | null | undefined): string => {
	if (lengthInInches === null || lengthInInches === undefined)
		lengthInInches = 0;
	const feet = Math.floor(lengthInInches / 12);
	const inches = lengthInInches % 12;
	return `${feet} ft ${inches} in`;
};

export const useScrapTableData = ({
	scrapReasons,
	editCallback,
	deleteCallback,
}: UseScrapTableDataProps) => {
	const scrapReasonsMap = new Map(
		scrapReasons.map((reason) => [
			reason.ScrapReasonId,
			reason.ScrapReasonName,
		]),
	);

	const columns: ColGroupDef[] = [
		{
			headerName: "Scrapped Pieces",
			children: [
				{
					field: "Length",
					headerName: "Length",
					flex: 1,
					minWidth: 78,
					valueFormatter: (params) => formatLength(params.value),
				},
				{
					field: "Pieces",
					headerName: "Pieces",
					flex: 1,
					minWidth: 64,
				},
				{
					field: "Strand",
					headerName: "Strand",
					flex: 1,
					minWidth: 60,
					valueFormatter: (params) => {
						return params.value ? `S${params.value}` : "";
					},
				},
				{
					headerName: "Code",
					flex: 1,
					minWidth: 110,
					valueGetter: (params) => {
						const codeId = params.data.ScrapReasonId;
						return codeId ? scrapReasonsMap.get(codeId) || "" : "";
					},
				},
				{
					field: "Weight",
					headerName: "Weight [lbs]",
					flex: 1,
					minWidth: 98,
				},
				{
					field: "actions",
					headerName: "",
					sortable: false,
					filter: false,
					flex: 1,
					minWidth: 70,
					maxWidth: 70,
					cellRenderer: (params: ICellRendererParams<ScrapData>) => {
						const rowData = params.data;
						return rowData ? (
							<AgGridButtons
								editItem={() => editCallback(rowData)}
								deleteItem={() => deleteCallback(rowData)}
							/>
						) : null;
					},
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef };
};
